import React, { useEffect, useState } from 'react'
import Card from '../../../components/Card'
import { Row, Col, Alert, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap'
// import GoogleMapReact from 'google-map-react';
// import { Marker, Polyline, GoogleMap } from 'react-google-maps';
import { GoogleMap, Marker, useLoadScript, Polyline, useJsApiLoader } from "@react-google-maps/api";
// import { GoogleApiWrapper, Map as GoogleMap } from 'google-maps-react';
import { userSignal } from '../../../signal/userSignal';
import { toast } from 'react-toastify';
import StartMarker from '../../../assets/images/icons/start-marker.svg'
import avatar1 from "../../../assets/images/avatars/01.png"
import { DEV_SERVER, GRPC_SERVER } from '../../../constants/urls';
import { CallOptions } from 'grpc-web';
import { allUsersSignal } from '../../../signal/allUsersSignal';
import { googleMapKey } from '../../../constants/googleMapKey';
import { myGrpsSignal } from '../../../signal/myGrpsSIgnals';

const { LiveTrackingRequest, Status } = require('../../../js-pb/location_tracking_pb.js')
const { LocationTrackingClient } = require('../../../js-pb/location_tracking_grpc_web_pb.js')

const Google = (props) => {
    const [locations, setLocations] = useState({})
    const [userDetails, setUserDetails] = useState([])
    const [search, setSearch] = useState([])
    const [center, setCenter] = useState({ lat: -33.847927, lng: 150.6517938 })
    const [selectedUser, setSelectedUser] = useState(null)
    // take location from ip address


    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: googleMapKey,
    });

    var grpc = new LocationTrackingClient(GRPC_SERVER);

    const resetData = () => {
        setLocations({})
        setUserDetails([])
        try {
            window.localStorage.removeItem("locations")
            window.localStorage.removeItem("userDetails")
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {

        let flag = false
        var liveTrackingRequest = new LiveTrackingRequest()
        liveTrackingRequest.setUserId(userSignal.value?.user?.id)
        liveTrackingRequest.setOrgId(userSignal.value?.user?.organisation)
        liveTrackingRequest.setName(userSignal.value?.user?.name)
        liveTrackingRequest.setUserType(userSignal.value?.user?.userType)
        liveTrackingRequest.setProfileUrl(userSignal.value?.user?.profileURL)

        var liveStream

        const liveStreamConnection = () => {
            liveStream = grpc.liveTracking(liveTrackingRequest);
            liveStream.on('data', function (response) {
                let userId = response.getUserId()

                if (!allUsersSignal.value[userId] || !myGrpsSignal.value.includes(allUsersSignal.value[userId]?.group)) {
                    console.log("returned")
                    return;
                }

                let locationslist = response.getLocationsList()
                let charging = response.getCharging()
                let distance = response.getDistance()

                let newLocations = []
                for (let i = 0; i < locationslist?.length; i += 2) {
                    newLocations.push({ lat: parseFloat(locationslist[i]), lng: parseFloat(locationslist[i + 1]) })
                }

                let locationsFromStorage = JSON.parse(window.localStorage.getItem("locations")) || {}

                let existingLocations = locationsFromStorage[userId] || []
                let userLocations = existingLocations
                // append the location to the list userLcoations
                userLocations = userLocations.concat(newLocations)
                let test = locationsFromStorage || {}
                test[userId] = userLocations
                // {...locations, [userId]: userLocations}
                window.localStorage.setItem("locations", JSON.stringify(test))

                let temp = JSON.parse(window.localStorage.getItem("userDetails")) || []
                let index = temp.findIndex((value) => value.userId === userId)
                if (index !== -1) {
                    temp[index] = { ...temp[index], charging, distance }
                } else {
                    temp.push({ userId, charging, distance })
                }

                window.localStorage.setItem("userDetails", JSON.stringify(temp))
                if (!flag) {
                    setLocations(test)
                    setUserDetails(temp)
                    flag = true
                }

            });

            liveStream.on('status', function (status) {
                // liveStream status signal
                console.log("liveTracking Status", status)
            });

            liveStream.on('end', function (end) {
                // liveStream end signal
                toast.error("You are disconnected, Please refresh!")
            });

            liveStream.on("error", function (err) {
                console.log("liveTracking error", err)
                try {
                    liveStream.cancel()
                } catch (err) {
                    console.log(err)
                }
                resetData()
                flag = false
                setTimeout(() => {
                    liveStreamConnection()
                }, 3000);
            })
        }
        liveStreamConnection()

        return () => {
            if (liveStream) {
                try {
                    liveStream.cancel()
                } catch (err) {
                    console.log(err)
                }
            }
        }

    }, [])

    useEffect(() => {

        try {
            window.localStorage.removeItem("locations")
            window.localStorage.removeItem("userDetails")
        } catch (err) {
            console.log(err)
        }

        let interval = setInterval(() => {
            let temp = JSON.parse(window.localStorage.getItem("userDetails")) || []
            setUserDetails(temp)
            let locationsFromStorage = JSON.parse(window.localStorage.getItem("locations")) || {}
            setLocations(locationsFromStorage)
        }, 10000)

        return () => {
            console.log("clearing interval")
            clearInterval(interval)
            try {
                window.localStorage.removeItem("locations")
                window.localStorage.removeItem("userDetails")
            } catch (err) {
                console.log(err)
            }
        }

    }, [])

    useEffect(() => {
        fetch('https://ipapi.co/json/')
            .then(res => res.json())
            .then(response => {
                setCenter({ lat: response.latitude, lng: response.longitude })
            })
            .catch(err => console.log(err));
    }, [])

    useEffect(() => {

        let flag = false
        var statusRequest = new Status()
        statusRequest.setUserId(userSignal.value?.user?.id)
        statusRequest.setOrgId(userSignal.value?.user?.organisation)
        statusRequest.setName(userSignal.value?.user?.name)
        statusRequest.setUserType(userSignal.value?.user?.userType)
        statusRequest.setProfileUrl(userSignal.value?.user?.profileURL)

        var statusStream

        const statusStreamConnection = () => {

            statusStream = grpc.statusTracking(statusRequest);
            statusStream.on('data', function (response) {
                let userId = response.getUserId()
                if (!allUsersSignal.value[userId] || !myGrpsSignal.value.includes(allUsersSignal.value[userId]?.group)) {
                    console.log("returned")
                    return;
                }
                let orgId = response.getOrgId()
                let name = response.getName()
                let userType = response.getUserType()
                let profileUrl = response.getProfileUrl()
                let status = response.getStatus()
                if (profileUrl === "") {
                    profileUrl = avatar1
                }
                let temp = JSON.parse(window.localStorage.getItem("userDetails")) || []
                let index = temp.findIndex((value) => value.userId === userId)
                if (index !== -1) {
                    temp[index] = { ...temp[index], userId, orgId, name, userType, profileUrl, status, color: `#${Math.floor(Math.random() * 16777215).toString(16)}` }
                } else {
                    temp.push({ userId, orgId, name, userType, profileUrl, status })
                }
                if (!flag) {
                    setUserDetails(temp)
                    if (selectedUser === null) {
                        setSelectedUser({
                            userId, orgId, name, userType, profileUrl, status, color: `#${Math.floor(Math.random() * 16777215).toString(16)}`
                        })
                    }
                    flag = true
                }
                window.localStorage.setItem("userDetails", JSON.stringify(temp))
            });
            statusStream.on('end', function (end) {
                // statusStream end signal
                toast.error("You are disconnected, Please refresh!")
            });

            statusStream.on('status', function (status) {
                // statusStream status signal
                console.log("statusTracking Status", status)
            });

            statusStream.on("error", function (err) {
                console.log("statusTracking error", err)

                try {
                    statusStream.cancel()
                } catch (err) {
                    console.log(err)
                }
                resetData()
                flag = false
                setTimeout(() => {
                    statusStreamConnection()
                }, 3000);
            })
        }

        statusStreamConnection()
        return () => {
            if (statusStream) {
                try {
                    statusStream.cancel()
                } catch (err) {
                    console.log(err)
                }
            }
        }

    }, [])

    return (
        <div style={{ width: "100%", height: "90vh" }}>
            {isLoaded &&
                <GoogleMap
                    mapContainerStyle={{ width: "100%", height: "100%" }}
                    zoom={17}
                    mapContainerClassName="map-container"
                    center={center}
                    options={{
                        streetViewControl: false,
                        zoomControl: false,
                        mapTypeControl: true,
                        fullscreenControlOptions: {
                            position: window.google.maps.ControlPosition.LEFT_TOP,
                        },
                    }}
                >

                    {/* // make small round at the start of the polyline */}

                    {/* {userDetails.map((val, i) => (
                        <div key={val?.userId}>
                            {locations[val?.userId]?.length > 0 && <Marker position={{ lat: locations[val?.userId]?.length > 0 ? locations[val?.userId][0]?.lat : 0, lng: locations[val?.userId]?.length > 0 ? locations[val?.userId][0]?.lng : 0 }} icon={{ url: StartMarker, scaledSize: new window.google.maps.Size(15, 15) }} shape={"rounded"} />}
                            {locations[val?.userId]?.length > 0 && <Marker position={{ lat: locations[val?.userId][locations[val?.userId]?.length - 1]?.lat, lng: locations[val?.userId][locations[val?.userId]?.length - 1]?.lng }} title={val?.name} icon={{
                                url: val?.profileUrl,
                                scaledSize: new window.google.maps.Size(40, 40)
                            }} />
                            }
                            <Polyline path={locations[val?.userId]}
                                options={{
                                    geodesic: true,
                                    strokeColor: val?.color,
                                    strokeOpacity: 1,
                                    strokeWeight: 6,
                                }}
                            />
                        </div>
                    ))} */}

                    {selectedUser &&
                        <div key={selectedUser?.userId}>
                            {locations[selectedUser?.userId]?.length > 0 && <Marker position={{ lat: locations[selectedUser?.userId]?.length > 0 ? locations[selectedUser?.userId][0]?.lat : 0, lng: locations[selectedUser?.userId]?.length > 0 ? locations[selectedUser?.userId][0]?.lng : 0 }} icon={{ url: StartMarker, scaledSize: new window.google.maps.Size(20, 20) }} shape={"rounded"} />}
                            {locations[selectedUser?.userId]?.length > 0 && <Marker position={{ lat: locations[selectedUser?.userId][locations[selectedUser?.userId]?.length - 1]?.lat, lng: locations[selectedUser?.userId][locations[selectedUser?.userId]?.length - 1]?.lng }} title={selectedUser?.name} icon={{
                                url: selectedUser?.profileUrl,
                                scaledSize: new window.google.maps.Size(30, 30)
                            }} />
                            }
                            <Polyline path={locations[selectedUser?.userId]}
                                options={{
                                    geodesic: true,
                                    strokeColor: selectedUser?.color,
                                    strokeOpacity: 1,
                                    strokeWeight: 6
                                }}
                            />
                        </div>

                    }

                    <div style={{ width: "200px", height: "100%", overflowY: 'scroll', background: "linear-gradient(to bottom, rgba(0,0,0,0.75), rgba(0,0,0,0.75))", position: "relative", display: "flex", float: "right", flexDirection: "column", rowGap: "1rem", paddingTop: "0.5rem" }}>
                        <input style={{ width: "90%", borderRadius: "9999px", padding: "0.2rem", paddingLeft: "0.8rem", margin: "0px auto", outline: "none" }} type='search' placeholder='search...' value={search} onChange={(e) => setSearch(e.target.value)}></input>

                        {userDetails?.length === 0 && <Alert variant="danger" style={{ width: "90%", margin: "0px auto" }}>No user on field</Alert>}
                        {userDetails.map((val, i) => {

                            if (search === "" || (val?.name && search !== "" && val?.name.toString().toLowerCase().includes(search.toString().toLowerCase()))) {
                                return (
                                    <div key={val?.userId} style={{ opacity: val?.status === "connected" ? 1 : 0.5, width: "100%" }} className='py-1 shadow'>
                                        <div style={{ display: "flex", width: "90%", alignItems: "center", columnGap: "0.7rem", paddingLeft: "0.7rem", cursor: "pointer" }} onClick={() => {

                                            if (locations[val?.userId]?.length > 0) {
                                                setCenter(locations[val?.userId][locations[val?.userId]?.length - 1])
                                                setSelectedUser(val)
                                            }
                                        }}>

                                            <img src={val.profileUrl} style={{ width: "25px", height: "25px", borderRadius: "50%", border: `2px solid ${val?.color}` }} />
                                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", fontSize: "12px", color: 'white' }}>
                                                <OverlayTrigger placement='top' overlay={<Tooltip style={{ position: "fixed" }}>{val?.name?.toString()}</Tooltip>}>
                                                    <span>{val?.name?.toString()?.length > 12 ? val?.name?.toString().slice(0, 12) + "..." : val?.name?.toString()} ({val?.charging}%)</span>
                                                </OverlayTrigger>
                                                <span style={{ color: "inherit", fontSize: "10px" }}>Distance: <b>{val?.distance ? (parseFloat(val?.distance / 1000)).toFixed(2) : "0"} km</b></span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            } else {
                                return <></>
                            }
                        }
                        )}
                    </div>

                </GoogleMap>
            }
        </div>
    )
}

// export default GoogleApiWrapper(
//     () => ({
//         apiKey: "AIzaSyBhsu2tPSwSPWJFRdqHVjJ3YsDC9sBaKSM",
//     }
//     ))(Google)

export default Google
